import createAttachment from '@/common/components/base/input/base/helpers/createAttachment.ts';
import CircularLoading from '@/common/components/base/Loading/CircularLoading.tsx';
const LoadingAttachment = createAttachment({
  element: <CircularLoading color="colors.purple-primary" width="30" />,
});

export default LoadingAttachment;
